import { Component, inject } from '@angular/core';
import { CatalogService } from '../../core/services/catalog.service';

@Component({
  selector: 'app-faqs',
  templateUrl: './faqs.component.html'
})
export class FaqsComponent {
  readonly faqs = inject(CatalogService).faqs;
}
